export const normalizeTeamIds = (
  teamIds: unknown,
  fallbackTeamId?: unknown
): number[] => {
  const parsedIds = Array.isArray(teamIds)
    ? teamIds
        .map(id => Number.parseInt(String(id), 10))
        .filter(id => Number.isInteger(id))
    : []

  if (parsedIds.length > 0) {
    return Array.from(new Set(parsedIds))
  }

  const fallback =
    typeof fallbackTeamId === 'number'
      ? fallbackTeamId
      : Number.isFinite(Number(fallbackTeamId))
        ? Number(fallbackTeamId)
        : null

  return fallback != null ? [Number(fallback)] : []
}

export const derivePrimaryTeamId = (
  teamIds: unknown,
  fallbackTeamId?: unknown
): number | null => {
  const normalized = normalizeTeamIds(teamIds, fallbackTeamId)
  return normalized.length > 0 ? normalized[0] : null
}
